import { Link } from "react-router-dom";

export default function Logo() {
  return (
    <Link
      to="/"
      onClick={() => window.scrollTo(0, 0)}
      className="inline-flex items-center gap-[10px] no-underline"
      style={{ cursor: "pointer" }}
      aria-label="Restricted Deals — home"
      data-testid="logo-link"
    >
      <svg
        className="w-7 h-7 md:w-9 md:h-9 shrink-0"
        viewBox="0 0 52 52"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <circle cx="26" cy="26" r="25" fill="#CC1A1A" stroke="white" strokeWidth="2.5" />
        <rect x="10" y="20" width="32" height="12" rx="2" fill="white" />
      </svg>

      <span
        className="text-[16px] md:text-[20px] font-bold leading-none tracking-[1px]"
        style={{ fontFamily: "'Courier New', Courier, monospace" }}
      >
        <span style={{ color: "#FFFFFF" }}>RESTRICTED</span>
        <span style={{ color: "#CC1A1A" }}>DEALS</span>
      </span>
    </Link>
  );
}
